import { Icon } from 'leaflet';

// export const icon = new Icon({
//     iconUrl: '/marker-icon.png',
//     iconSize: [25, 41], // size of the icon
//     iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
//     popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
// });

// export const icon = new Icon({
//     iconUrl: '/images/icons/location-pin.png',
//     iconSize: [40, 41], // size of the icon
//     iconAnchor: [18.9, 41], // point of the icon which will correspond to marker's location
//     popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
// });

// Function to create a custom SVG icon with the specified iconUrl and color

export const icon = (color = '#ff1a00') => {
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 0a8 8 0 0 0-8 8c0 1.421.382 2.75 1.031 3.906.108.192.221.381.344.563L12 24l6.625-11.531c.102-.151.19-.311.281-.469l.063-.094A7.954 7.954 0 0 0 20 8a8 8 0 0 0-8-8zm0 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" fill="${color}" class="fill-e74c3c"></path><path d="M12 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" fill="${color}" class="fill-c0392b"></path></svg>`;

    return new Icon({
        iconSize: [40, 41], // size of the icon
        iconAnchor: [18.9, 41], // point of the icon which will correspond to marker's location
        popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
        iconUrl: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
    });
};

export const slopePointIcon = (color = '#ff1a00') => {
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 0a8 8 0 0 0-8 8c0 1.421.382 2.75 1.031 3.906.108.192.221.381.344.563L12 24l6.625-11.531c.102-.151.19-.311.281-.469l.063-.094A7.954 7.954 0 0 0 20 8a8 8 0 0 0-8-8zm0 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" fill="${color}" class="fill-e74c3c"></path><path d="M12 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" fill="${color}" class="fill-c0392b"></path></svg>`;

    return new Icon({
        iconSize: [20, 21], // size of the icon
        iconAnchor: [9.9, 21], // point of the icon which will correspond to marker's location
        popupAnchor: [0, -21], // point from which the popup should open relative to the iconAnchor
        iconUrl: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
    });
};
